import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { configureAmplify } from '../config/aws.config';
import { LookupService } from '../services/lookup.service';
import { SingleResultApiResponse } from '../models/api-response.model';
import { AWSSettings } from '../models/aws-settings.model';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'online-app-welcome-agent',
  templateUrl: './welcome-agent.component.html',
  styleUrls: ['./welcome-agent.component.scss']
})
export class WelcomeAgentComponent implements OnInit, OnDestroy {

  showNotification: boolean;
  notificationMessage: string;
  phase1Decommissioned: boolean;

  constructor(private router: Router,
    private lookupService: LookupService,
    private renderer: Renderer2,
    private titleService: Title) {
    this.renderer.addClass(document.body, 'login-screen');
    this.titleService.setTitle("Online Application Portal - DE International - Agent");
  }

  ngOnInit() {

    this.lookupService.getAWSAuthSettings(true)
      .subscribe((response: SingleResultApiResponse) => {

        if (response.Result) {

          const awsSettings: AWSSettings = {
            Region: response.Result.Region,
            UserPoolId: response.Result.UserPoolId,
            UserPoolWebClientId: response.Result.UserPoolWebClientId,
            IdentityPoolId: response.Result.IdentityPoolId,
            AuthenticationFlowType: response.Result.AuthenticationFlowType,
            BucketName: response.Result.BucketName
          };

          localStorage.setItem('awsSettings', JSON.stringify(awsSettings));

          configureAmplify(true);
        }

      }, err => {
        console.log('error happened while calling AWS Auth Settings');
      });

    this.lookupService.getNotificationSettings(2)
      .subscribe((response: SingleResultApiResponse) => {
        if (response.Result) {
          this.showNotification = response.Result.Item1;
          this.notificationMessage = response.Result.Item2;
          this.phase1Decommissioned = response.Result.Item3;
        }
      }, err => {
        console.log('error happened while calling Notification Settings');
      });
  }


  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'login-screen');
  }

  signIn(): void {
    localStorage.clear();
    this.router.navigate(['/agent-login']);
  }

  // TODO: Remove this method - used for seed data
  registerAgent(): void {
    localStorage.clear();

    this.lookupService.getAWSAuthSettings(true)
      .subscribe((response: SingleResultApiResponse) => {

        if (response.Result) {

          const awsSettings: AWSSettings = {
            Region: response.Result.Region,
            UserPoolId: response.Result.UserPoolId,
            UserPoolWebClientId: response.Result.UserPoolWebClientId,
            IdentityPoolId: response.Result.IdentityPoolId,
            AuthenticationFlowType: response.Result.AuthenticationFlowType,
            BucketName: response.Result.BucketName
          };

          localStorage.setItem('awsSettings', JSON.stringify(awsSettings));

          configureAmplify(true);
          // this.authService
          // .registerAgent('jonathan.javier@det.nsw.edu.au', 'fakepwd', 'jonathan.javier@det.nsw.edu.au')
          // .subscribe(
          //   signUpResult => {
          //     // Show the user some msg asking them to confirm their email
          //     console.log('successfully registered with AWS Cognito for Agent');
          //     console.log(signUpResult);
          //   },
          //   (err: AWSCognitoErrorResponse) => {

          //     console.log(
          //       'error happened while registering the user with AWS Cognito'
          //     );
          //     console.log(err);
          //   }
          // );


          // this.authService.confirmAgentRegistration('jonathan.javier@det.nsw.edu.au', '531267')
          // .subscribe( result => {
          //   console.log('registration successful');
          //   console.log(result);
          // }, err => {
          //   console.log('error while confirming the registration');
          //   console.log(err);
          // });


        }

      }, err => {
        console.log('error happened while calling AWS Auth Settings');
      }, () => {

      });
  }
}
